/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PdfAnnotation
 */
export interface PdfAnnotation {
    /**
     * Text to place on the PDF
     * @type {string}
     * @memberof PdfAnnotation
     */
    text: string;
    /**
     * fieldKey of the originating FieldPlacement. Lets the server look up the field's type/constraints (e.g. homeowner_initials_*) to validate the submitted text server-side, independent of client-side checks.
     * @type {string}
     * @memberof PdfAnnotation
     */
    fieldKey?: string;
    /**
     * Page number (0-indexed)
     * @type {number}
     * @memberof PdfAnnotation
     */
    page: number;
    /**
     * X coordinate (percentage of page width, 0-100)
     * @type {number}
     * @memberof PdfAnnotation
     */
    x: number;
    /**
     * Y coordinate (percentage of page height, 0-100, top-down)
     * @type {number}
     * @memberof PdfAnnotation
     */
    y: number;
    /**
     * Field width as percentage of page width (used for text alignment)
     * @type {number}
     * @memberof PdfAnnotation
     */
    width?: number;
    /**
     * Field height as percentage of page height (used for vertical centering)
     * @type {number}
     * @memberof PdfAnnotation
     */
    height?: number;
    /**
     * Font size for text (default 12)
     * @type {number}
     * @memberof PdfAnnotation
     */
    fontSize?: number;
    /**
     * Font family name (e.g., Helvetica, Times-Roman, Courier). Defaults to Helvetica.
     * @type {string}
     * @memberof PdfAnnotation
     */
    fontFamily?: string;
    /**
     * Text alignment within the field. Defaults to left.
     * @type {string}
     * @memberof PdfAnnotation
     */
    textAlign?: PdfAnnotationTextAlignEnum;
    /**
     * Whether the text wraps across multiple lines (true) or stays on a single shrink-to-fit line (false). When omitted, the server treats the annotation as multiline if its text contains a newline character, and single-line otherwise.
     * @type {boolean}
     * @memberof PdfAnnotation
     */
    multiline?: boolean;
}


/**
 * @export
 */
export const PdfAnnotationTextAlignEnum = {
    Left: 'left',
    Center: 'center',
    Right: 'right'
} as const;
export type PdfAnnotationTextAlignEnum = typeof PdfAnnotationTextAlignEnum[keyof typeof PdfAnnotationTextAlignEnum];


/**
 * Check if a given object implements the PdfAnnotation interface.
 */
export function instanceOfPdfAnnotation(value: object): value is PdfAnnotation {
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('page' in value) || value['page'] === undefined) return false;
    if (!('x' in value) || value['x'] === undefined) return false;
    if (!('y' in value) || value['y'] === undefined) return false;
    return true;
}

export function PdfAnnotationFromJSON(json: any): PdfAnnotation {
    return PdfAnnotationFromJSONTyped(json, false);
}

export function PdfAnnotationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PdfAnnotation {
    if (json == null) {
        return json;
    }
    return {
        
        'text': json['text'],
        'fieldKey': json['fieldKey'] == null ? undefined : json['fieldKey'],
        'page': json['page'],
        'x': json['x'],
        'y': json['y'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'fontSize': json['fontSize'] == null ? undefined : json['fontSize'],
        'fontFamily': json['fontFamily'] == null ? undefined : json['fontFamily'],
        'textAlign': json['textAlign'] == null ? undefined : json['textAlign'],
        'multiline': json['multiline'] == null ? undefined : json['multiline'],
    };
}

export function PdfAnnotationToJSON(json: any): PdfAnnotation {
    return PdfAnnotationToJSONTyped(json, false);
}

export function PdfAnnotationToJSONTyped(value?: PdfAnnotation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'text': value['text'],
        'fieldKey': value['fieldKey'],
        'page': value['page'],
        'x': value['x'],
        'y': value['y'],
        'width': value['width'],
        'height': value['height'],
        'fontSize': value['fontSize'],
        'fontFamily': value['fontFamily'],
        'textAlign': value['textAlign'],
        'multiline': value['multiline'],
    };
}

